import styled, { css } from 'styled-components';
import { Switch as AntSwitch } from 'antd';
import { colors } from '@10d/tend-ui-tokens/samolet';

import { SwitchComponentProps, SwitchProps } from './types';

export const SwitchWrapper = styled.div<SwitchProps>`
  color: ${colors.gray900};
  display: flex;
  align-items: center;
  gap: 8px;
  line-height: 24px;

  ${({ size }) =>
    size === 'small' &&
    css`
      font-size: 12px;
      line-height: 20px;
    `}

  .ant-switch-handle {
    width: 16px;
    height: 16px;
    left: 3px;
    top: 3px;
  }

  .ant-switch-small .ant-switch-handle {
    width: 12px;
    height: 12px;
    left: 2px;
    top: 2px;
  }

  .ant-switch-checked .ant-switch-handle {
    left: calc(100% - 16px - 3px);
  }

  .ant-switch-small.ant-switch-checked .ant-switch-handle {
    left: calc(100% - 12px - 2px);
  }
`;

export const Switch = styled<SwitchComponentProps>(AntSwitch)`
  background-color: ${colors.gray400};

  &.ant-switch-checked {
    background-color: ${colors.blue600};
  }

  &.ant-switch-disabled {
    background-color: #d7dce9;
  }

  &.ant-switch-checked.ant-switch-disabled {
    background-color: ${colors.blue300};
  }
`;
